import { render, staticRenderFns } from "./informationDownload.vue?vue&type=template&id=6d2029d6&scoped=true&lang=pug&"
import script from "./informationDownload.vue?vue&type=script&lang=js&"
export * from "./informationDownload.vue?vue&type=script&lang=js&"
import style0 from "./informationDownload.vue?vue&type=style&index=0&id=6d2029d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2029d6",
  null
  
)

export default component.exports